module.exports = __webpack_public_path__ + "static/tel-2fe7ad11b78ff6d756792f1b9a7e326d.png";